"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _md = require("react-icons/md");

var _wrapperSidebarContext = require("../wrapperSidebarContext");

var S = _interopRequireWildcard(require("./ProfileAndLogout.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ProfileAndLogout = () => {
  var {
    session,
    isInMobile,
    logout
  } = (0, _react.useContext)(_wrapperSidebarContext.WrapperSidebarContext);
  return /*#__PURE__*/_react.default.createElement(S.ProfileAndLogout, null, /*#__PURE__*/_react.default.createElement(S.Profile, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://campus.axontraining.com/perfil",
    style: {
      color: 'white',
      fontSize: '1rem'
    }
  }, session.name)), /*#__PURE__*/_react.default.createElement(_md.MdLogout, {
    onClick: logout,
    color: "#FFF",
    cursor: "pointer",
    size: "1.5rem",
    style: {
      margin: "1rem 0 0 1rem"
    }
  }));
};

var _default = ProfileAndLogout;
exports.default = _default;